import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/MainContext";
import { useNavigate } from "react-router-dom";
import Admin from "./Admin";

const ProtectedRoute = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    } else if (user?.user_id === 3 || user?.user_id === 16) {
      setAuthenticated(true);
    } else {
      navigate("/", { replace: true });
    }
  }, [user, navigate]);

  return <>{authenticated && <Admin />}</>;
};

export default ProtectedRoute;
